import React, { useState, useEffect } from "react";
import axios from "axios";

const SubscriptionPage = () => {
  const [plans, setPlans] = useState([]);
  const [currentPlan, setCurrentPlan] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const shop =
    new URLSearchParams(window.location.search).get("shop") ||
    "victorgroups.myshopify.com";

  useEffect(() => {
    setLoading(true);
    axios
      .get("https://fr-xfinder.vercel.app/api/plans", {
        headers: { "Content-Type": "application/json" },
        params: { shop },
      })
      .then((res) => {
        setPlans(
          res.data.plans || [
            {
              planId: "free",
              name: "Free",
              price: 0,
              validationsLimit: 100,
              trialDays: 0,
              features: ["Basic validation", "100 validations/month"],
            },
            {
              planId: "standard",
              name: "Standard",
              price: 10,
              validationsLimit: 500,
              trialDays: 7,
              features: ["Standard validation", "500 validations/month"],
            },
            {
              planId: "premium",
              name: "Premium",
              price: 25,
              validationsLimit: 1000,
              trialDays: 14,
              features: ["Premium validation", "1000 validations/month"],
            },
            {
              planId: "enterprise",
              name: "Enterprise",
              price: 50,
              validationsLimit: "Unlimited",
              trialDays: 30,
              features: ["Unlimited validation", "Priority support"],
            },
          ]
        );
        setCurrentPlan(res.data.subscription || null);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.response?.data?.error || err.message);
        setLoading(false);
      });
  }, [shop]);

  const handleSubscribe = async (planId) => {
    setLoading(true);
    setError(null);
    try {
      const res = await axios.post(
        "https://fr-xfinder.vercel.app/billing/subscribe",
        { planId, shop },
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      if (res.data.confirmationUrl) {
        window.location.href = res.data.confirmationUrl;
      }
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">
          Subscription Plans
        </h1>
        {error && (
          <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-6 rounded-md">
            {error}
          </div>
        )}
        {currentPlan && (
          <div className="bg-white p-6 rounded-lg shadow-md mb-6">
            <h3 className="text-xl font-semibold text-gray-700 mb-2">
              Current Plan: {currentPlan.planName}
            </h3>
            <p className="text-gray-600">
              Validations Used: {currentPlan.validationsUsed}
            </p>
            <p className="text-gray-600">
              Validations Left:{" "}
              {currentPlan.validationsLimit === "Unlimited"
                ? "Unlimited"
                : currentPlan.validationsLeft}
            </p>
          </div>
        )}
        {loading ? (
          <div className="text-gray-600 text-center">Loading plans...</div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {plans.map((plan) => (
              <div
                key={plan.planId}
                className={`bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition-transform transform hover:-translate-y-1 ${
                  plan.planId === "professional"
                    ? "border-2 border-shopifyGreen"
                    : ""
                }`}
              >
                <h3 className="text-xl font-semibold text-gray-700 mb-2">
                  {plan.name}
                </h3>
                <p className="text-2xl font-bold text-shopifyGreen mb-2">
                  ${plan.price}
                  <span className="text-sm text-gray-500">/month</span>
                </p>
                <p className="text-sm text-green-600 mb-4">
                  {plan.trialDays} days free trial
                </p>
                <p className="text-gray-600 mb-4">
                  Validations: {plan.validationsLimit}/month
                </p>
                <ul className="text-gray-600 mb-6 space-y-2">
                  {plan.features.map((feature, index) => (
                    <li key={index} className="flex items-center">
                      <svg
                        className="w-5 h-5 text-shopifyGreen mr-2"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                      {feature}
                    </li>
                  ))}
                </ul>
                <button
                  onClick={() => handleSubscribe(plan.planId)}
                  disabled={loading || currentPlan?.planId === plan.planId}
                  className={`w-full py-2 rounded-md text-white font-semibold ${
                    loading || currentPlan?.planId === plan.planId
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-shopifyGreen hover:bg-shopifyGreen/90"
                  }`}
                >
                  {loading
                    ? "Processing..."
                    : currentPlan?.planId === plan.planId
                    ? "Current Plan"
                    : `Choose ${plan.name}`}
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SubscriptionPage;
